import Button from '@mui/joy/Button'
import Chip from '@mui/joy/Chip'
import Typography from '@mui/joy/Typography'
import ListItem from '@mui/joy/ListItem'
import ListItemButton from '@mui/joy/ListItemButton'
import ListItemContent from '@mui/joy/ListItemContent'
import { DeleteButton } from './ui/DeleteButton'

// TODO: Check to see if a mui component can handle some of this state stuff (i.e. selected)
export const TextPost = ({
    message,
    selected,
    isScheduled,
    onClick,
    onDelete,
    id,
}) => {
    return (
        <ListItem
            endAction={
                !isScheduled && <DeleteButton onClick={() => onDelete(id)} />
            }
        >
            <ListItemButton
                sx={{ p: 2 }}
                onClick={() => onClick(id)}
                selected={selected}
                disabled={isScheduled}
            >
                <ListItemContent
                    sx={{ display: 'flex', flexDirection: 'column' }}
                >
                    <Typography level="body-sm" mb={2}>
                        {message}
                    </Typography>
                    {isScheduled ? (
                        <Chip size="sm" variant="soft" color="success">
                            Scheduled
                        </Chip>
                    ) : (
                        <Chip size="sm" variant="soft" color="neutral">
                            Needs Scheduling
                        </Chip>
                    )}
                </ListItemContent>
            </ListItemButton>
        </ListItem>
    )
}
